import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './FeaturesSection.scss';
import Section from './Section';
import FeatureBlock from './FeatureBlock';
import ListIcon from '../../assets/images/icons/list.svg';
import StarIcon from '../../assets/images/icons/star.svg';
import DocumentIcon from '../../assets/images/icons/document.svg';
import LocationIcon from '../../assets/images/icons/location.svg';
import RadioIcon from '../../assets/images/icons/radio.svg';
import SocialIcon from '../../assets/images/icons/social.svg';
import WhiteShareIcon from '../../assets/images/icons/white-share.svg';
import PublisherIcon from '../PublisherIcon';
import TicketIcon from '../../assets/images/icons/ticket.svg';
import GraphIcon from '../../assets/images/icons/graph.svg';
import MegaphoneIcon from '../../assets/images/icons/megaphone.svg';
import TrafficNumber from '../TrafficNumber';
import { getPublishersByVisitors, visitorsSum } from 'lib/parsePublishers';

export default class FeaturesSection extends Component {

  static propTypes = {
    features: PropTypes.object.isRequired,
    featuringPublisher: PropTypes.object.isRequired,
    publishers: PropTypes.object.isRequired,
    inputRef: PropTypes.func.isRequired
  };

  render() {
    const { features, featuringPublisher, inputRef, availablePublishersCount } = this.props;

    const publishersByVisitors = getPublishersByVisitors(this.props.publishers);
    return (
      <Fragment>
        <Section title="Features" id="features-section" subtitle={<span>Promote your event across multiple marketing channels access premium <br/>
        features and placements to reach local consumers.</span>}/>
        <div className={`section ${styles.featureSection}`}>
          <FeatureBlock icon={ListIcon} title="An Event Listing"
            description="Your event submission is turned in to an event listing instantly."/>
          <FeatureBlock icon={StarIcon} title="Featured Position Online"
            description="Your event in a featured position on the calendars home, category and content pages."/>
          <FeatureBlock icon={LocationIcon} title="Premium Map Pin"
            description="Map pin has enlarged placement on the home and category page maps.."/>
          {features.print && <FeatureBlock icon={DocumentIcon} title="Print"
            description="Print featured placement the week of your event"/>}
          {featuringPublisher && featuringPublisher.get('radio_enabled') &&
          <FeatureBlock icon={RadioIcon} title="Radio"
            description="Your event played over the radio station."/>}
          {/*<FeatureBlock icon={EmailIcon} title="Targeted Email"*/}
          {/*  description="Your event converted to email and sent to targeted consumers locally."/>*/}
          <FeatureBlock icon={SocialIcon} title="Social Reposting"
            description="Promote your event via social media and and reach publishers social media followers."/>
        </div>
        <div className={`section ${styles.syndicateSection}`} ref={inputRef}>
          <div className="header">
            <div className="small-circle evvnt-bg">
              <img src={WhiteShareIcon}/>
            </div>
            <h4>
            Syndicate your event to relevant and targeted event listing sites and calendars.
            </h4>
            <div className="description">
              We have selected a range of news media publishers that want <br/> events content like yours.
              <br/>
              <div className={styles.trafficBox}>
                Traffic Statistics Total of <strong className={styles.trafficBig}>
                  <TrafficNumber traffic={visitorsSum(publishersByVisitors)}/>
                </strong> Monthly Unique Visitors
                from <strong className={styles.trafficBig}>{availablePublishersCount}</strong> Publishers
              </div>
            </div>
            <div className="publisher-logos">
              {publishersByVisitors.map((publisher) => {
                return (<PublisherIcon publisher={publisher} key={`publisher-icon-${publisher.get('id')}`} />);
              }) }
            </div>
          </div>
        </div>

        <div className="section">
          <div className={styles.featureSection}>
            <FeatureBlock icon={TicketIcon} title="Ticketing"
              description="Use our ticketing services, or add your own to get clear registration and revenue reporting back from your event marketing activities."/>
            <FeatureBlock icon={GraphIcon} title="Detailed Event Progress Report"
              description="Per event analytics report on clicks, source, tickets and revenue."/>
            <FeatureBlock icon={MegaphoneIcon} title="Promotion last until your event ends"
              description="Submit your event early and see it listed from today through till the day of the event."/>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/snapsell/FeaturesSection.jsx